import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import './Resume.css';

const experiences = [
  {
    title: 'Software Engineer - III',
    company: 'Cisco',
    location: 'Bangalore, India',
    date: 'May 2023 - Present',
    logo: '/images/logo/Cisco.png',
    type: 'work',
    promotions: [
      { title: 'Software Engineer II', date: 'May 2023 - Oct 2025' },
      { title: 'Software Engineer III', date: 'Oct 2025 - Present' },
    ],
  },
  {
    title: 'Member of Technical Staff - I',
    company: 'Mavenir',
    location: 'Bhubaneswar, India',
    date: 'Jul 2021 - May 2023',
    logo: '/images/logo/Mavenir.png',
    type: 'work',
    promotions: [
      { title: 'Graduate Software Engineer', date: 'Jul 2021 - Jul 2022' },
      { title: 'Member of Technical Staff I', date: 'Jul 2022 - May 2023' },
    ],
  },
  {
    title: 'Computer Science and Engineering',
    company: 'Bachelor of Technology',
    location: 'Veer Surendra Sai University of Technology, Burla',
    date: 'Aug 2017 - Jun 2021',
    logo: '/images/logo/VSSUT.png',
    type: 'education',
  },
  {
    title: 'Data Analytics Intern',
    company: 'Chargeback Gurus',
    location: 'Chennai, India',
    date: 'Dec 2020 - Jun 2021',
    logo: '/images/logo/ChargebackGurus.png',
    type: 'work',
  },
  {
    title: 'ML & AI Intern',
    company: 'Digital Tesseract',
    location: 'Chennai, India',
    date: 'Apr 2020 - Aug 2020',
    logo: '/images/logo/DigitalTesseract.png',
    type: 'work',
  },
  {
    title: 'HPC & DL Intern',
    company: 'Center for Development of Advanced Computing',
    location: 'Pune, India',
    date: 'Dec 2018 - Jan 2019',
    logo: '/images/logo/CDAC.png',
    type: 'work',
  },
];

function TimelineItem({ item, index }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-80px' });
  const isLeft = index % 2 === 0;

  return (
    <motion.div
      ref={ref}
      className={`timeline__item ${isLeft ? 'timeline__item--left' : 'timeline__item--right'}`}
      initial={{ opacity: 0, x: isLeft ? -50 : 50 }}
      animate={isInView ? { opacity: 1, x: 0 } : {}}
      transition={{ duration: 0.7, delay: 0.1, ease: [0.4, 0, 0.2, 1] }}
    >
      <div className="timeline__dot">
        <img src={item.logo} alt={item.company} className="timeline__logo" />
      </div>
      <div className="timeline__card">
        {item.promotions ? (
          <>
            <h4 className="timeline__company">{item.company}</h4>
            <span className="timeline__date">{item.date}</span>
            <p className="timeline__location timeline__location--top">
              <i className="fa-solid fa-location-dot" /> {item.location}
            </p>
            <div className="timeline__roles">
              {[...item.promotions].reverse().map((role, i) => (
                <div key={i} className="timeline__role">
                  <div className="timeline__role-marker">
                    <span className="timeline__role-dot" />
                    {i < item.promotions.length - 1 && <span className="timeline__role-line" />}
                  </div>
                  <div className="timeline__role-info">
                    <h3 className="timeline__role-title">{role.title}</h3>
                    <span className="timeline__role-date">{role.date}</span>
                  </div>
                </div>
              ))}
            </div>
          </>
        ) : (
          <>
            <span className="timeline__date">{item.date}</span>
            <h3 className="timeline__title">{item.title}</h3>
            <h4 className="timeline__company">{item.company}</h4>
            <div className="timeline__divider" />
            <p className="timeline__location">
              <i className="fa-solid fa-location-dot" /> {item.location}
            </p>
          </>
        )}
      </div>
    </motion.div>
  );
}

function Resume() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section id="resume" className="resume" ref={ref}>
      <div className="resume__inner">
        <div style={{ textAlign: 'center' }}>
          <motion.h2
            className="section-title"
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
            style={{ position: 'relative', left: 'auto', transform: 'none', display: 'inline-block' }}
          >
            ./Experience
          </motion.h2>
          <motion.div
            className="section-title-underline"
            initial={{ scaleX: 0 }}
            animate={isInView ? { scaleX: 1 } : {}}
            transition={{ duration: 0.6, delay: 0.3, type: 'spring', stiffness: 200, damping: 20 }}
            style={{ transformOrigin: 'center' }}
          />
        </div>

        <div className="timeline">
          <div className="timeline__line" />
          {experiences.map((item, i) => (
            <TimelineItem key={i} item={item} index={i} />
          ))}
          <div className="timeline__end">
            <i className="fa-solid fa-star" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Resume;
